import { IonContent, IonPage } from '@ionic/react';
import React from 'react';
import ContactInfoCard from '../../../../../components/Dashboard/settings/help-support/ContactInfoCard';
import { chatbubbleOutline, chatbubblesOutline } from 'ionicons/icons';

export default function ContactInformationPage() {
  return (
    <IonPage>
      <IonContent>
        <div className="pr-2 space-y-4">
          <p className="medium-emphasis-text">
            Our friendly team is always here to chat.
          </p>
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 w-full">
            <ContactInfoCard
              icon={chatbubbleOutline}
              theme="blue"
              header="Phone Support"
              subtitle="Available 24/7 for emergencies"
            >
              <ul className="font-medium space-y-2 text-customs-dark-blue">
                <li>+2348036555170</li>
                <li>+447345160443</li>
              </ul>
            </ContactInfoCard>
            <ContactInfoCard
              icon={chatbubblesOutline}
              theme="green"
              header="Live Chat"
              href="wa.me/+2348036555170"
              linkLabel="Start Chat"
              subtitle={`Monday - Sunday, \n 8AM - 10PM`}
            />
            <ContactInfoCard
              icon={chatbubblesOutline}
              theme="lavender"
              header="Email"
              href="mailto:hello@swiftmedix.com"
              linkLabel="Email Us"
              subtitle={`hello@swiftmedix.com`}
            />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
